const PartnerTermsPage: React.FC = () => {
  window.location.href = 'https://snappt.com/partner-terms/';
  return <div></div>;
};

export default PartnerTermsPage;
